import React from "react";

const FormStepIndicator = ({ currentStep, mobile, origem }) => {

    const steps = [
        "Endereço de entrega",
        "Produtos",
        "Contatos de entrega",
        ...(origem === 'C' ? ["Restrições de entrega"] : []),
        "Obrigado!",
    ];

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
            }}
        >
            {steps.map((label, index) => {
                const isActive = index + 1 === currentStep;
                const isCompleted = index + 1 < currentStep;

                return (
                    <div
                        key={label}
                        style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "flex-end",
                        }}
                    >
                        <div
                            style={{
                                color: isActive || isCompleted ? "black" : "#999",
                                fontWeight: isActive ? "bold" : "normal",
                                borderBottom: `6px solid ${isActive ? "#D11D22" : isCompleted ? "#32CE6A" : "#eee"
                                    }`,
                                paddingBottom: "12px",
                                transition: "all 0.3s ease",
                                fontSize: mobile === true ? "12px" : '16px',
                                textAlign: mobile === true ? "center" : "left",
                                lineHeight: "1.2",
                                minHeight: mobile === true ? "36px" : null, // garante altura igual para todos
                                wordWrap: mobile === true ? "break-word" : null, // permite quebra controlada
                                whiteSpace: mobile === true ? "normal" : null, // garante que texto pode quebrar
                                width: "100%",
                            }}
                        >
                            {label}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FormStepIndicator;
